import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import {
  genURL,
  gengetURLTEST,
  genpostURL,
  genpostURLTEST,
} from "./../_getjson";
import { Row, Col, Panel } from "react-bootstrap";
import PopUpItem from "./../PopUp/PopUpItem";
import PopupArcode from "./../PopUp/PopUpArcode";
import PopUpOther, { CreditCode, SERIALNUMBER } from "../PopUp/PopUpOther";
import _PopUpwarehouse from "./../PopUp/PopUpwarehouse";
import _popupissuereq from "./../PopUp/Popupissuereq";
import { parseJwt } from "../parseJWT";
import PopUpSearchDoc from "./../PopUp/PopUpSearch_draw";
import PopUpReport from "./../PopUp/_fromShow";
import { checkunit } from "../_source/checkUnit";
import Checkdocgroup from "./../CustomFunction/Docgroup/Checkdocgroup";
import Chackdocno from "./../CustomFunction/Docno/GetDocno";
import ChackAr from "./../CustomFunction/Csar/GetAr";
import CheckUser from "./../CustomFunction/Csuser/GetUser";
import CheckBrabchname from "./../CustomFunction/Branch/Checkname";
import CheckDepartmentname from "./../CustomFunction/Department/Checkname";
import Backdrop from "./../Components/CustomBackdrop/Barckdrop";
import axios from "axios";
import Snackbar from "./../Components/Snackbar/Snackbar";
import ErrorIcon from "@mui/icons-material/ErrorOutlineRounded";
import MaterialUIPickers from "./../Components/CustomDatepicker/MaterialUIPickers";
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";

import Checkstock from "./../CustomFunction/Product/ChkStock";
import Topbar from "../Components/Customtopbar/Topbar";
import FullScreenDialog from "../PopUp/FullScreendialogs/FullScreen";
import SelectDatas from "./../PopUp/SelectData";
import CustomInputtext from "./../Components/CustomInput/Inputtext";
import Rechecked from "./Components/Rechecked";
import { Grid } from "@mui/material";
import CheckCodeDocGroup from "../CustomFunction/Docgroup/CheckCodeDocGroup";
import SelectStkJobOrder from "./Components/SelStkJobOrder/SelectStkJobOrder";
import ProductAssembly from "./Components/ProductAssembly/productAssembly";
const listmenu = [
  ["เลือกใบขอเบิกสินค้า", "popupissuereq"],
  ["เลือกใบสั่งผลิต", "stkJobOrder"],
  ["รวมประกอบสินค้าอัตโนมัติ", "productAssembly"],
];

const Checktxt = (value) => {
  var data = value ? value : "";
  return data;
};
require("../_css/Productbring.css");
export default class Productbring extends Component {
  constructor(props) {
    super(props);
    this.Groupdata_code = React.createRef();
    this.Groupdata = React.createRef();
    this.DeliNumber = React.createRef();
    this.CustomerCode = React.createRef();
    this.CustomerName = React.createRef();
    this.Csuser_code = React.createRef();
    this.Csuser = React.createRef();
    this.remark = React.createRef();
    this.Issuetype_code = React.createRef();
    this.Issuetype = React.createRef();
    this.defaultwarehouse = React.createRef();
    this.Department_code = React.createRef();
    this.Department = React.createRef();
    this.ProductCode2 = React.createRef();
    this.Branch_code = React.createRef();
    this.Branch = React.createRef();
    this.MileNo = React.createRef();
    this.state = {
      tableData: [],
      rowtb: "300",
      cellname: "",
      rowClick: "",
      sdefaultwarehouse: "",
      sdefaultwarehousename: "",
      OtPopupType: "",
      Groupdata_txt: "",
      Issuetype_txt: "",
      Department_txt: "",
      Branch_txt: "",
      sdefaultlocation: "",
      sdefaultlocationName: "",
      Departmentname: "",
      Branchname: "",
      sduedate: "",
      sremark: "",
      sserialnumber: "",
      sEnableedit: false,
      openBackdrop: false,
      autoClose: 3600,
      color: "warning",
      messagealert: "",
      siteCodeUser1: "",
      checkenableInput: [],
      PROJECT: "",
      defaultvaluewarehouse: "",
      defaultwarehouse: "",
      defaultlocetion: "",
      productAssemblyData: [],
    };
  }

  async componentDidMount() {
    await this.setState({
      checkenableInput: JSON.parse(localStorage.getItem("checkoftxt")),
    });
    let SITECODESTR = parseJwt(localStorage.getItem("Token"));
    this.setState({ siteCodeUser: SITECODESTR.User.SITECODE });
    this.setState({ siteCodeUser1: SITECODESTR.User.CODE });
    this.onAddValue("Branch", SITECODESTR.User.SITECODE);
    this.setRow(this.state.rowtb);
    this.onAddValue("Csuser", SITECODESTR.User.CODE);
    this.MileNo.current.value = parseFloat(0).toFixed(2);
  }
  _onSave = async () => {
    const parameter = new URLSearchParams();
    parameter.append("CREATEUSER", localStorage.getItem("Username"));
    parameter.append("DOCNO", this.DeliNumber.current.value);
    parameter.append("REMARK", this.remark.current.value);
    parameter.append("ARCODE", this.CustomerCode.current.value);
    parameter.append("ARNAME", this.CustomerName.current.value);
    parameter.append("ISSUETYPE", this.Issuetype_code.current.value);
    parameter.append("DOCGROUP", this.Groupdata_code.current.value);
    parameter.append("DEPARTMENT", this.Department_code.current.value);
    parameter.append("SITECODE", this.Branch_code.current.value);
    parameter.append("COMPUTERNAME", "");
    parameter.append("ProductCode2", this.ProductCode2.current.value);
    parameter.append("MileNo", this.MileNo.current.value);
    parameter.append("withdrawaldate", this.state.withdrawaldate);
    parameter.append(
      "provenance",
      window.location.hostname === "localhost" ? "" : "Web"
    );
    parameter.append("PROJECT", this.state.PROJECT);
    parameter.append(
      "productAssemblyData",
      JSON.stringify(this.state.productAssemblyData)
    );
    let product = this.state.tableData;
    var productArr = [];
    var sarr = [];
    var Uststus = true;
    for (let index = 0; index < product.length; index++) {
      if (product[index].T_Code !== undefined && product[index].T_Code !== "") {
        productArr[index] = {
          Productcode: product[index].T_Code /* 0 รหัสสินค้า */,
          Productname: product[index].T_Product /* 1 ชื่อสินค้า */,
          Warehouse: product[index].T_Treasury /* 2 คลัง */,
          Location: product[index].T_Location /* 3 ตำแหน่งเก็บ */,
          Unitcode: product[index].T_Unitcode /* 4 หน่วย */,
          Quantity: Checktxt(product[index].T_QTY) /* 5 ปริมาณ */,
          Refdocno: product[index].T_Request /* 6 ใบขอเบิก */,
          Productset: product[index].PRODUCTSET /* 7 PRODUCTSET */,
          Stocktype: product[index].STOCKTYPE /* 8 STOCKTYPE */,
          Refdoctype: Checktxt(product[index].REFDOCTYPE) /* 9 REFDOCTYPE */,
          Refqty: Checktxt(product[index].REFQTY) /* 10 REFQTY */,
          Reflineid: Checktxt(product[index].reflineID) /* 11 reflineID */,
        };
        sarr.push(productArr[index]);

        if (
          product[index].T_Code === "" ||
          product[index].T_Product === "" ||
          product[index].T_Treasury === "" ||
          product[index].T_Location === "" ||
          product[index].T_Unit === "" ||
          product[index].T_QTY === ""
        ) {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "กรุณากรอกข้อมูลในตารางให้ครบ" });
          Uststus = false;
          break;
        }
        if (product[index].T_QTY === "0.00" || product[index].T_QTY === "NaN") {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ให้กำหนดปริมาณก่อน" });
          Uststus = false;
          break;
        }
      }
    }
    parameter.append("listItem", JSON.stringify(sarr));
    for (var pair of parameter.entries()) {
      console.log(pair);
      if (pair[1] === "" && pair[0] === "DOCGROUP") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณาเลือกกลุ่มข้อมูล" });
      } else if (pair[1] === "" && pair[0] === "ISSUETYPE") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณาเลือกประเภทการเบิก" });
      } else if (pair[1] === "" && pair[0] === "SITECODE") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณาเลือกสาขา" });
      } else if (pair[1] === "" && pair[0] === "DEPARTMENT") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณาเลือกแผนก" });
      } else if (pair[1] === "" && pair[0] === "ITEMS") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณาเลือกสินค้า" });
      } else if (pair[1] === "" && pair[0] === "REMARK") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกหมายเหตุ" });
        return;
      } else if (pair[1] === "" && pair[0] === "ARCODE") {
        Uststus = false;
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "กรุณากรอกรหัสลูกค้า" });
        return;
      }
    }
    if (Uststus === true) {
      this.setState({ openBackdrop: true });
      await axios
        .post(genpostURL(`CSSTKISSUE/Save?`), parameter)
        .then((res) => {
          //   await axios.post(genpostURLTEST(`/Save?`), parameter).then(res => {
          if (res.data.status === "success") {
            this.setState({ opensnackbar: true });
            this.setState({ open: false });
            this.setState({ color: "success" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "บันทึกสำเร็จ" });
            setTimeout(() => {
              this.setState({ openBackdrop: false });
              this._ResetThisPage();
            }, 30);
          } else {
            this.setState({ open: false });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({
              messagealert: "บันทึกไม่สำเร็จ" + res.data.status,
            });
            this.setState({ opensnackbar: true });
            this.setState({ openBackdrop: false });
          }
        })
        .catch((error) => {
          this.setState({ open: false });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "เกิดข้อผิดพลาด" + error });
          this.setState({ opensnackbar: true });
          this.setState({ openBackdrop: false });
          console.log(error);
        });
    }
  };
  setRow = (count) => {
    var data = [];
    for (var i = 0; i <= count - 1; i++) {
      data[i] = {
        N: i + 1,
        T_Code: "",
        T_Product: "",
        T_Treasury: "",
        C3_insert: "",
        T_Location: "",
        C4_insert: "",
        T_Unitcode: "",
        T_Unit: "",

        T_QTY: "",
        serial_insert: "",
        btn_serial: "",
        reflineID: "",
      };
    }
    this.setState({ tableData: data });
  };
  //**************************************************************************popup**************************************************************************************/
  _setPopup = (data) => {
    switch (data) {
      case "customer":
        this.setState({
          OtPopupType: data,
          titleFullScreenDialog: "รายการลูกค้า",
          typeFullScreenDialog: data,
          openFullScreenDialog: true,
        });

        this.setState({ OtPopupType: data });
        this.setState({ showPopupArcode: !this.state.showPopupArcode });
        break;
      case "setdefaultwarehouse":
      case "setdefaultwarehousetable":
        this.setState({
          OtPopupType: data,
          titleFullScreenDialog: "คลังสินค้า",
          typeFullScreenDialog: data,
          openFullScreenDialog: true,
        });
        break;
      case "product":
        this.setState({
          OtPopupType: data,
          titleFullScreenDialog: "รายการสินค้า",
          typeFullScreenDialog: data,
          openFullScreenDialog: true,
        });
        break;
      case "Groupdata":
        // this.setState({ OtPopupType: data })
        // this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
        this.setState({
          OtPopupType: data,
          titleFullScreenDialog: "กลุ่มข้อมูล",
          typeFullScreenDialog: data,
          openFullScreenDialog: true,
        });
        break;
      case "Issuetype":
      case "unitStockintable":
        // this.setState({ OtPopupType: data })
        // this.setState({ showPopupot: !this.state.showPopupot });
        this.setState({
          OtPopupType: data,
          titleFullScreenDialog:
            data === "Issuetype" ? "ประเภทการเบิก" : "หน่วยนับ",
          typeFullScreenDialog: data,
          openFullScreenDialog: true,
        });
        break;
      case "Department":
        this.setState({
          OtPopupType: data,
          titleFullScreenDialog: "แผนก",
          typeFullScreenDialog: data,
          openFullScreenDialog: true,
        });
        // this.setState({ OtPopupType: data })
        // this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
        break;
      case "Branch":
        this.setState({
          OtPopupType: data,
          titleFullScreenDialog: "สาขา",
          typeFullScreenDialog: data,
          openFullScreenDialog: true,
        });
        // this.setState({ OtPopupType: data })
        // this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
        break;
      case "popupissuereq":
        this.setState({
          OtPopupType: data,
          titleFullScreenDialog: "คันหาใบขอเบิก",
          typeFullScreenDialog: data,
          openFullScreenDialog: true,
        });
        break;
    }
  };
  Switch_OtherPopup = (type) => {
    this.setState({ OtPopupType: type });
    this.setState({ SwitchOtherPopup: !this.state.SwitchOtherPopup });
  };
  _popupClose = (data) => {
    switch (data) {
      case "customer":
        this.setState({ showPopupArcode: !this.state.showPopupArcode });
        break;
      case "product":
        this.setState({ showPopupproduct: !this.state.showPopupproduct });
        break;
      case "Groupdata":
        this.setState({ showPopupGroup: !this.state.showPopupGroup });
        break;
      case "setdefaultwarehouse":
      case "setdefaultwarehousetable":
        this.setState({ showPopupwarehouse: !this.state.showPopupwarehouse });
        break;
      case "close_PopUpOther":
        switch (this.state.OtPopupType) {
          case "unitStockintable":
            this.setState({ showPopupot: !this.state.showPopupot });
            break;
          case "Department":
            this.setState({
              showPopupDepartment: !this.state.showPopupDepartment,
            });
            break;
          case "Branch":
            this.setState({ showPopupotBranch: !this.state.showPopupotBranch });
            break;
          case "popupissuereq":
            this.setState({ openFullScreenDialog: false });
            break;
        }
        break;
    }
  };
  Get_PopUpItem = (code, data, stockCode) => {
    this.AddDataTable(
      code,
      this.state.cellname,
      this.state.rowClick,
      stockCode
    );
  };
  _getPopUparcode = (data1, data2) => {
    this.CustomerCode.current.value = data1.trim();
    this.CustomerName.current.value = data2.trim();
  };
  Get_PopUpOther = async (val) => {
    console.log("val" + val);
    console.log("val this.state.OtPopupType :" + this.state.OtPopupType);

    var data = val.split("|");
    for (var i = 0; i < data.length; i++) {
      data[i] = data[i].trim();
    }
    switch (this.state.OtPopupType) {
      case "Groupdata":
        this.Groupdata_code.current.value = data[0];
        this.Groupdata.current.value = data[1];
        this.setState({ Groupdata_txt: data[1] });
        await Chackdocno(data[0], "CSSTKISSUE")
          .then(async (result1) => {
            if (result1 !== undefined) {
              this.DeliNumber.current.value = await result1;
            } else {
              this.DeliNumber.current.value = "";
            }
          })
          .catch((err) => {
            this.DeliNumber.current.value = "";
            console.log(err);
          });
        break;
      case "Department":
        this.Department_code.current.value = await data[0];
        this.Department.current.value = await data[1];
        this.setState({ Department_txt: data[1] });
        break;
      case "Branch":
        this.Branch_code.current.value = await data[0];
        this.Branch.current.value = await data[1];
        this.setState({ Branch_txt: data[1] });
        break;
      case "Branch":
        this.Branch_code.current.value = await data[0];
        this.Branch.current.value = await data[1];
        this.setState({ Branch_txt: data[1] });
        break;
      case "Issuetype":
        this.Issuetype.current.value = await data[1];
        this.Issuetype_code.current.value = await data[0];
        break;
      default:
        break;
    }
  };
  _getwarehouse = async (data) => {
    console.log(data);
    var DataValue = data.split("|");
    var Pr = this.state.tableData;
    var r = this.state.WHRow;
    Pr[r].T_Treasury = DataValue[0];
    Pr[r].T_Location = DataValue[2];
    // Pr[r].MaxUnit = DataValue[4];
    await this.setState({ tableData: Pr });
  };
  _getIteminPopup = (data, dataDetail) => {
    switch (this.state.OtPopupType) {
      case "Issuetype":
        this.Issuetype_code.current.value = this._spritData(data, "|")[0];
        this.Issuetype.current.value = this._spritData(data, "|")[1];
        this.setState({ Issuetype_txt: this._spritData(data, "|")[1] });
        break;
      case "unitStockintable":
        this.setState({ sEnableedit: false });
        this.AddDataTable(data, this.state.cellname, this.state.rowClick);
        // this.Branch.current.value = this._spritData(data,"|")[1];
        // this.setState({ Branchname: this._spritData(data,"|")[0] });
        break;
      case "selstkissuereq":
        this.setState({ sEnableedit: false });
        // this.AddDataTable(data, "otCname", this.state.rowClick);
        break;
    }
  };
  //************************************************************************sprit*************************************************************************************** */
  _spritData(data, text) {
    var str = data.split(text);
    return str;
  }
  _cellButtonC1(cell, row, enumObject, rowIndex) {
    var btn = this.state.tableData[rowIndex].BTN_Code;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <i
            className="fas fa-search"
            style={{ cursor: "pointer", fontSize: "14px", paddingTop: "7px" }}
            onClick={this._setPopup.bind(null, "product")}
            onMouseDown={(e) => {
              this.setState({ TBLastClick: row.N });
            }}
          ></i>
        );
        break;
      default:
        btnShow = <i className=""></i>;
        break;
    }
    return <div>{btnShow}</div>;
  }
  _cellButtonC3(cell, row, enumObject, rowIndex) {
    var btn = this.state.tableData[rowIndex].BTN_Treasury;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <i
            className="fas fa-search"
            style={{ cursor: "pointer", fontSize: "14px", paddingTop: "7px" }}
            onClick={this._setPopup.bind(null, "setdefaultwarehousetable")}
          ></i>
        );
        break;
      default:
        btnShow = <i className=""></i>;
        break;
    }
    return <div>{btnShow}</div>;
  }
  _cellButtonC4(cell, row, enumObject, rowIndex) {
    var btn = this.state.tableData[rowIndex].BTN_Location;
    var btnShow = "";
    switch (btn) {
      case 1:
        btnShow = (
          <i
            className="fas fa-search"
            style={{ cursor: "pointer", fontSize: "14px", paddingTop: "7px" }}
            onClick={this._setPopup.bind(null, "setdefaultwarehousetable")}
          ></i>
        );
        break;
      default:
        btnShow = <i className=""></i>;
        break;
    }
    return <div>{btnShow}</div>;
  }
  _chkload(cell, row, enumObject, rowIndex) {
    return (
      <div>
        <i id={"load" + rowIndex}>{rowIndex + 1}</i>
      </div>
    );
  }
  _onRowClick = (row, col, id) => {
    this.setState({ cellValue: row.T_Code });
    this.setState({ rowClick: row.N - 1 });
    var Pr = this.state.tableData;
    this.setState({ WHRow: id });
    var j = 20;

    // ไม่ให้คีย์ข้ามแถว
    this.setState({ col1: false });
    this.setState({ col: false });

    // จำนวนเต็มเวลาคลิก
    var T_QTY = row.T_QTY;
    if (col === 9 && T_QTY !== "" && T_QTY !== undefined) {
      row.T_QTY = parseFloat(T_QTY).toFixed(0);
    }

    /* this._cleandata(); */

    for (var i = 0; i < Pr.length; i++) {
      Pr[i].BTN_Code = 0;
      Pr[i].BTN_Treasury = 0;
      Pr[i].BTN_Location = 0;
      /* Pr[i].btn_C5 = 0; 
            Pr[i].btn_serial = 2;  */
    }

    // หาจากล่างขึ้นบน
    for (var i = this.state.tableData.length - 1; i >= 0; i--) {
      //หา แถวที่ว่างบนสุดใน products Table
      if (!this.state.tableData[i].T_Code) {
        j = i;
      }
    }

    // BTN ค้นหาได้เฉพาะในแถว
    if (
      (col === 1 && j === id) ||
      (col === 1 && Pr[id].T_Code !== undefined && Pr[id].T_Code !== "")
    ) {
      this.setState({ cellname: "T_Code" });
      this.setState({ col1: true });
      Pr[row.N - 1].BTN_Code = 1;
      this.setState({ tableData: Pr });
    } else if (col === 4) {
      this.setState({ cellname: "T_Treasury" });
      if (typeof row.T_Code !== "undefined" && row.T_Code !== "") {
        this.setState({ productcodeinrow: row.T_Code });
        this.setState({ productcodeinrow1: row.T_Treasury });
        Pr[row.N - 1].BTN_Treasury = 1;
        this.setState({ tableData: Pr });
      }
    } else if (col === 6) {
      this.setState({ cellname: "T_Location" });
      if (typeof row.T_Code !== "undefined" && row.T_Code !== "") {
        this.setState({ productcodeinrow: row.T_Code });
        this.setState({ productcodeinrow1: row.T_Treasury });
        Pr[row.N - 1].BTN_Location = 1;
        this.setState({ tableData: Pr });
      }
    } else if (col === 8) {
      this.setState({ cellname: "T_Unit" });
      Pr[row.N - 1].btn_C5 = 1;
      this.setState({ tableData: Pr });
    } else if (col === 13) {
      this.setState({ cellname: "serial_insert" });
      this.setState({ se_PRODUCTCODE: row.T_Code });
      Pr[row.N - 1].btn_serial = 1;
      this.setState({ tableData: Pr });
    }

    // ให้เพิ่มข้อมูลในแถวที่มีรหัสสินค้าได้
    if (typeof row.T_Code !== "undefined" && row.T_Code !== "") {
      this.setState({ col: true });
    }

    setTimeout(() => {
      this.setState({ tableData: Pr });
    }, 30);
  };
  SelectSetData = (type, data) => {
    switch (type) {
      case "Calendar":
        this.setState({ withdrawaldate: data });
        break;
      case "PROJECT":
        this.setState({ PROJECT: data });
        break;
      default:
        break;
    }
  };
  AddDataTable = async (ItemCode, row) => {
    let col = this.state.tableData;
    /* รหัสสินค้าซ้ำกันเพิ่มจำนวน ปริมาณ */
    for (var i = 0; i < col.length; i++) {
      if (col[i].T_Code === ItemCode) {
        // col[i].T_QTY = parseFloat(Number(col[i].T_QTY) + 1).toFixed(2);
        // this.setState({ tableData: col });
        return;
      }
    }
    var url =
      "CSPRODUCT/GetAllProductcode?code=" +
      ItemCode +
      "&user=" +
      localStorage.getItem("Username");
    console.log(genURL(url));
    axios
      .get(genURL(url), { timeout: 4800 })
      .then(async (res) => {
        console.log(res.data);
        let data = res.data;
        var j = this.state.rowintable;
        //หา แถวที่ว่างบนสุดใน products Table
        if (row > -1) {
          j = row;
        } else if (this.state.TBLastClick && this.state.TBLastClick > -1) {
          j = this.state.TBLastClick - 1;
        } else {
          for (var i = this.state.tableData.length - 1; i >= 0; i--) {
            // หาจากล่างขึ้นบน
            if (!this.state.tableData[i].tableData) {
              j = i;
            }
          }
        }
        if (data.length > 0) {
          let C3_Datainsert = this.state.sdefaultwarehouse;
          let C4_Datainsert = this.state.sdefaultlocation;
          for (let i = 0; i < data.length; i++) {
            //เพิ่มขอมูลทั้งหมด ลง products Table
            var MAINGROUP = "",
              STOCKTYPE = 0;
            console.log("PRODUCTSET", res.data[i].PRODUCTSET);
            var url1 =
              "CSPRODUCT/Code?productset=" +
              data[i].PRODUCTSET +
              "&stocktype=&code=" +
              data[i].PRODUCTCODE;
            console.log(genURL(url1));
            await axios
              .get(genURL(url1), { timeout: 3600 })
              .then(async (result) => {
                console.log(result.data);
                if (result.data.length > 0) {
                  MAINGROUP =
                    (await result.data[0].MAINGROUP) == undefined
                      ? ""
                      : result.data[0].MAINGROUP;
                  STOCKTYPE = await result.data[0].STOCKTYPE;
                }
              });
            //ชื่อหน่วย
            var unit = "";
            await checkunit(res.data[i].UNITCODE).then((data) => {
              unit = data;
              console.log(unit);
            });
            col[j] = {
              N: this.state.tableData[j].N,
              T_Code: data[i].PRODUCTCODE,
              T_Product: data[i].PRODUCTNAME,
              T_Treasury: this.state.defaultwarehouse,
              C3_insert: C3_Datainsert,
              T_Location: this.state.defaultlocetion,
              C4_insert: C4_Datainsert,
              T_Unitcode: data[i].UNITCODE,
              T_Unit: unit,
              T_QTY: (0).toFixed(2),
              T_Request: "",
              MaxUnit: 0,
              MAINGROUP: MAINGROUP,
              PRODUCTSET:
                data[i].PARENTCODE === data[0].PRODUCTCODE
                  ? "2"
                  : String(data[i].PRODUCTSET),
              STOCKTYPE: STOCKTYPE,
            };
            this.setState({ tableData: col });
            setTimeout(() => {
              this.setunitname(j);
            }, 50);
            // } else {
            //     this.setState({ opensnackbar: true })
            //     this.setState({ color: "warning" })
            //     this.setState({ icon: ErrorIcon })
            //     this.setState({ messagealert: "จำนวนสินค้าไม่พอสำหรับทำรายการ" })
            // }
            // })
          }
          this.onAddValue("Department");
        }
        setTimeout(() => {
          this.setState({ sEnableedit: true });
          this._cleandata();
        }, 50);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  _getArcode = (event) => {
    var url = "";
    if (event === "CustomerCode" && this.CustomerCode.current.value !== "") {
      var arcode = this.CustomerCode.current.value;
      url =
        "CSAR/ARCode?arcode=" +
        arcode +
        "&user=" +
        localStorage.getItem("Username");
    } else if (event.key === "Enter") {
      var arcode = event.target.value.trim();
      url =
        "CSAR/ARCode?arcode=" +
        arcode +
        "&user=" +
        localStorage.getItem("Username");
    } else {
      return; //--------------- Exit เมื่อไม่เข้าเงือนไขไหนเลย
    }
    console.log(genURL(url));
    axios
      .get(genURL(url), { timeout: 3600 })
      .then((res) => {
        this.CustomerCode.current.value = "";
        this.CustomerName.current.value = "";
        if (res.data.length === 1) {
          this.CustomerCode.current.value = res.data[0].CODE;
          this.CustomerName.current.value = res.data[0].NAMETH;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  //**************************_afterSaveCell*********************************//
  _afterSaveCell = async (row, cellName, cellValue) => {
    // ทศนิยม 2 ตำแหน่ง จำนวนเงิน
    if (row.T_Code) {
      if (
        cellName === "T_QTY" &&
        Number(cellValue) > 0 &&
        row.STOCKTYPE !== 1
      ) {
        await Checkstock(
          row.T_Code,
          "",
          row.T_Unitcode,
          row.T_Treasury,
          row.T_Location,
          row.MAINGROUP,
          ""
        ).then(async (resstock) => {
          console.log("ChkStock resstock", resstock);
          if (Number(row.T_QTY) > Number(resstock)) {
            if (Number(resstock) > 0) {
              row.T_QTY = await parseFloat(resstock).toFixed(2);
            } else {
              row.T_QTY = await parseFloat(0).toFixed(2);
            }
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({
              messagealert:
                row.T_Code +
                " จำกัดสินค้าไม่พอใช้งาน ในคลังมีจำนวน " +
                resstock +
                " " +
                row.T_Unit,
            });
          } else {
            row.T_QTY = await parseFloat(cellValue).toFixed(2);
          }
        });
      } else {
        row.T_QTY = parseFloat(row.T_QTY).toFixed(2);
      }
    }
    var cellValue1 = this.state.cellValue;
    if (cellName === "T_Code" && cellValue != "" && cellValue1 != cellValue) {
      var col = this.state.tableData;
      col[row.N - 1] = [];
      col[row.N - 1].N = row.N;
      col[row.N - 1].T_Code = "";
      // col[row.N - 1].BTN_Code = row.BTN_Code;
      this.setState({ tableData: col });
      this.setState({ sEnableedit: false });
      this.AddDataTable(cellValue, row.N - 1);
    } else if (cellName === "T_Code" && cellValue === "") {
      setTimeout(() => {
        this.ReLoadData();
      }, 250);
    } else if (cellName !== "T_Code") {
      this.ReLoadData();
    }
    if (
      (cellName === "T_Treasury" || cellName === "T_Location") &&
      cellValue !== ""
    ) {
      var col = this.state.tableData;
      var select = "0";
      if (cellName === "T_Location") {
        select = "1";
      }
      this._loadData(row.T_Code, cellValue, select).then(async (res) => {
        console.log(res);
        if (res) {
          console.log("222");
          var maxunit = col[row.N - 1].MaxUnit;
          col[row.N - 1].T_Treasury = res.WAREHOUSE;
          col[row.N - 1].T_Location = res.LOCATION;
          console.log(row);
          await Checkstock(
            row.T_Code,
            "",
            row.T_Unitcode,
            res.WAREHOUSE,
            res.WAREHOUSE + "001",
            Number(row.MAINGROUP)
          ).then((resstock) => {
            console.log(resstock);
            maxunit = parseFloat(resstock).toFixed(2);
            col[row.N - 1].MaxUnit = maxunit;
          });
        } else {
          col[row.N - 1].T_Treasury = "";
          col[row.N - 1].T_Location = "";
          col[row.N - 1].MaxUnit = "0";
        }
        this.setState({ tableData: [...col] });
      });
    }
  };
  //เรียงข้อมูลใหม่ ลบแถวที่ ไม่มีรหัสสินค้า แล้วเลื่อนขึ้นมา คำนวนราคา
  ReLoadData = () => {
    var col = this.state.tableData;
    var NewCol = [],
      j = 0,
      Ch = 0;
    for (var i = 0; i < col.length; i++) {
      if (col[i].T_Code) {
        if (col[i].T_Code[0] + "" + col[i].T_Code[1] === "11") {
          Ch++;
        }
        NewCol[j] = col[i];
        NewCol[j].N = j + 1;
        NewCol[j].BTN_DelDate = 1;
        NewCol[j].BTN_C3 = 1;
        NewCol[j].BTN_C4 = 1;
        NewCol[j].BTN_C5 = 1;
        j++;
      }
    }
    for (var i = j; i < col.length; i++) {
      NewCol[j] = { N: j + 1 };
      j++;
    }
    this.setState({ tableData: NewCol });
  };
  _cleandata = () => {
    try {
      let array = this.state.tableData;
      array.forEach((element) => {
        if (element.T_Code === "") {
          element.T_Product = "";
          element.T_Treasury = "";
          element.T_Location = "";
          element.T_Unit = "";
          element.T_QTY = "";
          element.T_Request = "";
          element.T_Jobno = "";
          element.C3_insert = "";
          element.C4_insert = "";
          element.T_Unitcode = "";
          element.serial_insert = "";
          element.reflineID = "";
        }
      });
    } catch (error) {
      console.log(error);
    }
    // setTimeout(() => {
    //     this._chkDatanull();
    // }, 30);
  };
  _chkrowDatanull = () => {
    let data_2 = this.state.tableData;
    for (let index = 0; index <= data_2.length; index++) {
      try {
        if (data_2[index].T_Code !== "") {
          data_2[index - 1].T_Code = data_2[index].T_Code;
          data_2[index - 1].T_Product = data_2[index].T_Product;
          data_2[index - 1].T_Treasury = data_2[index].T_Treasury;
          data_2[index - 1].T_Location = data_2[index].T_Location;
          data_2[index - 1].T_Unit = data_2[index].T_Unit;
          data_2[index - 1].T_QTY = data_2[index].T_QTY;
          data_2[index - 1].T_Request = data_2[index].T_Request;
          data_2[index - 1].C3_insert = data_2[index].C3_insert;
          data_2[index - 1].C4_insert = data_2[index].C4_insert;
          data_2[index - 1].T_Unitcode = data_2[index].T_Unitcode;
          data_2[index - 1].reflineID = data_2[index].reflineID;
          data_2[index].T_Code = "";
          data_2[index].T_Product = "";
          data_2[index].T_Treasury = "";
          data_2[index].T_Location = "";
          data_2[index].T_Unit = "";
          data_2[index].T_QTY = "";
          data_2[index].T_Request = "";
          data_2[index].C3_insert = "";
          data_2[index].C4_insert = "";
          data_2[index].T_Unitcode = "";
        }
      } catch (error) {
        console.log("err=>" + error);
      }
    }
    this.setState({
      tableData: data_2,
    });
  };
  _handleKeyDown = (event) => {
    if (event.key === "Enter") {
      this._chkData(event.target.name, event.target.value);
    }
  };
  onAddValue = async (type, value, Fix) => {
    if (value) {
      switch (type) {
        case "Groupdata":
          Checkdocgroup(value, "CSSTKISSUE", Fix)
            .then(async (result) => {
              if (result !== "") {
                this.Groupdata_code.current.value = value;
                this.Groupdata.current.value = result;
                this.setState({ Groupdata_txt: result });
                if (Fix !== "Y") {
                  await Chackdocno(value, "CSSTKISSUE")
                    .then((result1) => {
                      if (result1 !== "") {
                        this.DeliNumber.current.value = result1;
                      } else {
                        this.DeliNumber.current.value = "";
                      }
                    })
                    .catch((err) => {
                      this.DeliNumber.current.value = "";
                      console.log(err);
                    });
                }
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({ messagealert: "ไม่พบข้อมูล!" });
                this.Groupdata_code.current.value = "";
                this.Groupdata.current.value = "";
                this.setState({ Groupdata_txt: "" });
                this.DeliNumber.current.value = "";
              }
            })
            .catch((err) => {
              this.Groupdata_code.current.value = "";
              this.Groupdata.current.value = "";
              this.setState({ Groupdata_txt: "" });
              this.DeliNumber.current.value = "";
              console.log(err);
            });
          break;
        case "CustomerCode":
          await ChackAr(value)
            .then((result) => {
              if (result !== "") {
                let data = result.split("|");
                this.CustomerCode.current.value = value;
                this.CustomerName.current.value = data[0];
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({ messagealert: "ไม่พบข้อมูล!" });
                this.CustomerCode.current.value = "";
                this.CustomerName.current.value = "";
              }
            })
            .catch((err) => {
              this.CustomerCode.current.value = "";
              this.CustomerName.current.value = "";
              console.log(err);
            });
          break;
        case "Csuser":
          await CheckUser(value)
            .then(async (result) => {
              if (result !== "") {
                this.Csuser_code.current.value = await value;
                this.Csuser.current.value = await result;
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({ messagealert: "ไม่พบข้อมูล!" });
                this.Csuser_code.current.value = "";
                this.Csuser.current.value = "";
              }
            })
            .catch((err) => {
              this.Csuser_code.current.value = "";
              this.Csuser.current.value = "";
              console.log(err);
            });
          break;
        case "Department":
          await CheckDepartmentname(value)
            .then((result) => {
              if (result !== "") {
                this.Department_code.current.value = value;
                this.Department.current.value = result;
                this.setState({ Department_txt: result });
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({ messagealert: "ไม่พบข้อมูล!" });
                this.Department_code.current.value = "";
                this.Department.current.value = "";
                this.setState({ Department_txt: "" });
              }
            })
            .catch((err) => {
              this.Department_code.current.value = "";
              this.Department.current.value = "";
              this.setState({ Department_txt: "" });
              console.log(err);
            });
          break;
        case "Branch":
          await CheckBrabchname(value)
            .then((result) => {
              if (result !== "") {
                this.Branch_code.current.value = value;
                this.Branch.current.value = result;
                this.setState({ Branch_txt: result });
              } else {
                this.setState({ opensnackbar: true });
                this.setState({ color: "warning" });
                this.setState({ icon: ErrorIcon });
                this.setState({ messagealert: "ไม่พบข้อมูล!" });
                this.Branch_code.current.value = "";
                this.Branch.current.value = "";
                this.setState({ Branch_txt: "" });
              }
            })
            .catch((err) => {
              this.Branch_code.current.value = "";
              this.Branch.current.value = "";
              this.setState({ Branch_txt: "" });
              console.log(err);
            });
          break;
        default:
          break;
      }
    }
  };
  _chkData = async (nametarget, val) => {
    switch (nametarget) {
      case "Issuetype":
        this.setState({ openBackdrop: true });
        var url = "CSISSUETYPE/GETCODE?Code=" + val;
        console.log(genURL(url));
        axios
          .get(genURL(url), { timeout: 3600 })
          .then((res) => {
            let data = res.data;
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                this.setState({ Issuetype_txt: data[i].MYNAMETH });
                this.Issuetype.current.value = data[i].MYNAMETH;
                this.Issuetype_code.current.value = data[i].CODE;
                this.setState({ openBackdrop: false });
              }
            } else {
              this.setState({ opensnackbar: true });
              this.setState({ color: "warning" });
              this.setState({ icon: ErrorIcon });
              this.setState({ messagealert: "ไม่พบข้อมูล!" });
              this.setState({ Issuetype_txt: "" });
              this.Issuetype.current.value = "";
              this.Issuetype_code.current.value = "";
              this.setState({ openBackdrop: false });
            }
          })
          .catch((error) => {
            console.log(error);
            this.setState({ Issuetype_txt: "" });
            this.Issuetype.current.value = "";
            this.Issuetype_code.current.value = "";
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้!" });
            this.setState({ openBackdrop: false });
          });
        break;
      case "CustomerCode":
        this.setState({ openBackdrop: true });
        var url =
          "CSAR/ARCode?arcode=" +
          val.trim() +
          "&user=" +
          localStorage.getItem("Username");
        await axios
          .get(genURL(url), { timeout: 3600 })
          .then((res) => {
            let data = res.data;
            if (data.length > 0) {
              this.CustomerCode.current.value = data[0].CODE.trim();
              this.CustomerName.current.value = data[0].NAMETH;
              this.setState({ openBackdrop: false });
            } else {
              this.setState({ opensnackbar: true });
              this.setState({ color: "warning" });
              this.setState({ icon: ErrorIcon });
              this.setState({ messagealert: "ไม่พบข้อมูล!" });
              this.CustomerCode.current.value = "";
              this.CustomerCode.current.focus();
              this.setState({ openBackdrop: false });
            }
          })
          .catch((error) => {
            console.log(error);
            this.setState({ opensnackbar: true });
            this.setState({ color: "warning" });
            this.setState({ icon: ErrorIcon });
            this.setState({ messagealert: "ไม่สามารถโหลดข้อมูลได้!" });
            this.setState({ openBackdrop: false });
          });

        break;
      default:
        break;
    }
  };
  _onNew = (e) => {
    this.componentDidMount();
  };
  _selectSetData = (type, data) => {
    switch (type) {
    }
  };
  _BeforeSaveCell() {}
  _ResetThisPage() {
    window.location.replace("/CSProductbring");
  }
  _Get_popupissuereq = async (data, Department) => {
    var split_data;
    let col = this.state.tableData;
    data.forEach((element) => {
      split_data = element.split("|");
      //  console.log(split_data);  "TS1001-640317-001|00001881|ถุงมือกันลื่น ตุ๊กแก ครึ่งนิ้ว|ชิ้น|1.00|1001|1001001| 145990010080|นางสาวอารา สุทธิประภา|1001|03|01|เบิกเพื่อเคลม|ทดสอบ ออนเว็บ ยาววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววววว|02|0|999"
      var j = col.length;
      for (var i = this.state.tableData.length - 1; i >= 0; i--) {
        // หาจากล่างขึ้นบน
        if (!this.state.tableData[i].T_Code) {
          j = i;
        }
      }
      //for(let index=0)
      for (var i = 0; i < col.length; i++) {
        // console.log(col[i].T_Code, "---", split_data[1]);
        if (
          col[i].T_Code !== split_data[1] &&
          (col[i].T_Code === undefined || col[i].T_Code === "")
        ) {
          col[j] = {
            N: j + 1,
            T_Code: split_data[1],
            T_Product: split_data[2],
            T_Treasury: split_data[5],
            T_Location: split_data[6],
            T_Unit: split_data[3],
            T_QTY: split_data[4],
            T_Request: split_data[0],
            C3_insert: split_data[5],
            C4_insert: split_data[6],
            T_Unitcode: split_data[14],
            reflineID: split_data[15],
            REFDOCTYPE: split_data[16],
            STOCKTYPE: split_data[17],
            PRODUCTSET: split_data[18],
            REFQTY: split_data[19],
          };
        } else if (
          col[i].T_Code === split_data[1] &&
          col[i].T_Treasury === split_data[5]
        ) {
          break;
        }
        this.setState({ products: col });
      }
    });
    this.CustomerCode.current.value = split_data[7];
    this.CustomerName.current.value = split_data[8];
    await CheckDepartmentname(Department).then((result) => {
      this.Department_code.current.value = Department;
      this.Department.current.value = result;
      this.setState({ Department_txt: result });
    });

    await CheckBrabchname(split_data[9])
      .then((result) => {
        if (result !== "") {
          this.Branch_code.current.value = split_data[9];
          this.Branch.current.value = result;
          this.setState({ Branch_txt: result });
        } else {
          this.setState({ opensnackbar: true });
          this.setState({ color: "warning" });
          this.setState({ icon: ErrorIcon });
          this.setState({ messagealert: "ไม่พบข้อมูล" });
          this.Branch_code.current.value = "";
          this.Branch.current.value = "";
          this.setState({ Branch_txt: "" });
        }
      })
      .catch((err) => {
        this.Branch_code.current.value = "";
        this.Branch.current.value = "";
        this.setState({ Branch_txt: "" });
        console.log(err);
      });
    // console.log("split_data[12]------Issuetype---------code", split_data[12], 'split_data[10]', split_data[10]);
    this.Issuetype.current.value = split_data[12];
    this.Issuetype_code.current.value = split_data[10];
    // this.remark.current.value = ""//split_data[13]
  };

  reCheckData = async (type, val, fix) => {
    switch (type) {
      case "Groupdata":
        CheckCodeDocGroup(val, "CSSTKISSUE")
          .then((result) => {
            console.log("result Groupdata", result);
            this.Groupdata_code.current.value = val;
            this.Groupdata.current.value = result;
            this.setState({ Docgroupname: result });
          })
          .finally((_) => {});
        break;
    }
  };

  _reCHK = async (RowData) => {
    this.setState({
      readData: false,
      openFullScreenDialog: false,
    });
    var url = "CSSTKISSUE/Getcodemain?code=" + RowData[0].docNo;
    console.log(genURL(url));
    await axios
      .get(genURL(url))
      .then(async (res) => {
        console.log("res", res);
        if (res.data.length > 0) {
          this.setState({
            defaultvaluewarehouse:
              "รหัสคลัง: " +
              res.data[0].SITECODE +
              "  รหัสที่เก็บ: " +
              res.data[0].SITECODE +
              "001",
          });
          this.setState({ withdrawaldate: RowData.C1 });
          this.CustomerCode.current.value = res.data[0].ARCODE;
          this.CustomerName.current.value = res.data[0].ARNAME;
          this.DeliNumber.current.value = res.data[0].DOCNO;
          this.remark.current.value = res.data[0].REMARK;
          this._chkData("Issuetype", res.data[0].ISSUETYPE);
          // this.onAddValue("Groupdata", res.data[0].DOCGROUP, "Y")
          await this.reCheckData("Groupdata", res.data[0].DOCGROUP, true);
          this.onAddValue("Csuser", res.data[0].USERCODE);
          this.onAddValue("Department", res.data[0].DEPARTMENT);
          this.onAddValue("Branch", res.data[0].SITECODE);
          this.ProductCode2.current.value = res.data[0].ProductCode2;
          this.MileNo.current.value = res.data[0].MileNo;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    var url1 = "CSSTKISSUE/Getcodesub?top=300&code=" + RowData[0].docNo;
    console.log("CSSTKISSUE", genURL(url1));
    await axios
      .get(genURL(url1), { timeout: 6000 })
      .then(async (res) => {
        if (res.data.length > 0) {
          var data = this.state.tableData;
          for (var i = 0; i < res.data.length; i++) {
            var unit = "";
            await checkunit(res.data[i].UNITCODE).then((data) => {
              unit = data;
            });
            data[i].T_Code = res.data[i].PRODUCTCODE;
            data[i].T_Product = res.data[i].PRODUCTNAME;
            data[i].T_Treasury = res.data[i].WAREHOUSE;
            data[i].T_Location = res.data[i].LOCATION;
            data[i].T_Unitcode = res.data[i].UNITCODE;
            data[i].T_Unit = unit;
            data[i].T_QTY = res.data[i].QUANTITY;
            data[i].T_Request = res.data[i].REFDOCNO;
            if (i === res.data.length - 1) {
              await this.setState({ tableData: data });
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  switchshowform = (e) => {
    this.setState({ showform: !this.state.showform });
  };
  _print = (e) => {
    if (this.DeliNumber.current.value !== "") {
      this._callForm(this.DeliNumber.current.value);
    }
    // this.setState({ SwitchReport: !this.state.SwitchReport });
  };
  _callForm = (vel) => {
    let url1 = process.env.REACT_APP_REPORTURL;
    let url2 =
      "&api_key=0WXZeIZXvvbBEoIotvJSC7H3vXnoPfRul9xNdF1u&j_username=rpt&j_password=042615116&output=pdf";
    let url3 = "&docno=" + this.DeliNumber.current.value;
    this.setState({
      urlsend:
        url1 +
        "flow.html?_flowId=viewReportFlow&_flowId=viewReportFlow&ParentFolderUri=%2Freports%2FPSMT_report%2FPSMT_FROM&reportUnit=%2Freports%2FPSMT_report%2FPSMT_FROM%2FCSSTKISSUE&standAlone=true" +
        url2 +
        url3,
    });
    setTimeout(() => {
      this.switchshowform();
    }, 100);
  };
  onSearch = (e) => {
    var data = this.state.tableData;
    for (var i = 0; i < data.length; i++) {
      data[i].T_Code = "";
      data[i].T_Product = "";
      data[i].T_Treasury = "";
      data[i].T_Location = "";
      data[i].T_Unit = "";
      data[i].T_Unitcode = "";
      data[i].T_QTY = "";
      data[i].T_Request = "";
      data[i].T_Jobno = "";
      data[i].C9 = "";
      data[i].discount = "";
      data[i].C10 = "";
      this.setState({ products: data });
    }
  };
  Chackdoc = () => {
    Chackdocno(this.Groupdata_code.current.value, "CSSTKISSUE")
      .then(async (result1) => {
        if (result1 !== undefined) {
          this.DeliNumber.current.value = await result1;
        } else {
          this.DeliNumber.current.value = "";
        }
      })
      .catch((err) => {
        this.DeliNumber.current.value = "";
        console.log(err);
      });
  };
  onClick = (e) => {
    if (e.target.value !== "") {
      switch (e.target.name) {
        case "Groupdata":
          this.Groupdata.current.value = this.Groupdata_code.current.value;
          break;
        case "Issuetype":
          this.Issuetype.current.value = this.Issuetype_code.current.value;
          break;
        case "Department":
          this.Department.current.value = this.Department_code.current.value;
          break;
        case "Branch":
          this.Branch.current.value = this.Branch_code.current.value;
          break;
        default:
          break;
      }
    }
  };
  onKeyDown = (e) => {
    if (e.key === "Enter") {
      if (e.target.name === "Groupdata") {
        this.onAddValue("Groupdata", e.target.value);
      }
      if (e.target.name === "CustomerCode") {
        this.onAddValue("CustomerCode", e.target.value);
      }
      if (e.target.name === "Issuetype") {
        this._chkData("Issuetype", e.target.value);
      }
      if (e.target.name === "Department") {
        this.onAddValue("Department", e.target.value);
      }
      if (e.target.name === "Branch") {
        this.onAddValue("Branch", e.target.value);
      }
    }
  };
  onChange = (e) => {
    switch (e.target.name) {
      case "Groupdata":
        if (e.target.value === "") {
          this.setState({ Groupdata_txt: "" });
          this.Groupdata_code.current.value = "";
          this.DeliNumber.current.value = "";
        }
        break;
      case "CustomerCode":
        if (e.target.value === "") {
          this.CustomerCode.current.value = "";
          this.CustomerName.current.value = "";
        }
        break;
      case "Issuetype":
        if (this.Issuetype.current.value === "") {
          this.setState({ Issuetype_txt: "" });
          this.Issuetype_code.current.value = "";
        }
        break;
      case "Department":
        if (e.target.value === "") {
          this.setState({ Department_txt: "" });
          this.state.Department_txt = "";
        }
        break;
      case "Branch":
        if (e.target.value === "") {
          this.setState({ Branch_txt: "" });
          this.Branch_code.current.value = "";
        }
        break;
      default:
        break;
    }
  };
  onBlur = (e) => {
    if (e.target.name === "Groupdata") {
      this.Groupdata.current.value = this.state.Groupdata_txt;
    }
    if (e.target.name === "Issuetype") {
      this.Issuetype.current.value = this.state.Issuetype_txt;
    }
    if (e.target.name === "Department") {
      this.Department.current.value = this.state.Department_txt;
    }
    if (e.target.name === "Branch") {
      this.Branch.current.value = this.state.Branch_txt;
    }
    // if (e.target.name === "withdrawaldate") {
    //     if (e.target.value !== "") {
    //         this.withdrawaldate.current.value = cheackdate(this.withdrawaldate.current.value)
    //         setTimeout(() => {
    //             if (cheackdate(this.withdrawaldate.current.value) === "") {
    //                 this.withdrawaldate.current.focus()
    //                 this.setState({ opensnackbar: true })
    //                 this.setState({ color: "warning" })
    //                 this.setState({ icon: ErrorIcon })
    //                 this.setState({ messagealert: "รูปแบบวันที่ไม่ถูกต้อง" })
    //             }
    //         }, 500);
    //     }
    // }
  };
  setunitname = async (j) => {
    let item = this.state.tableData;
    console.log("sssssssssss", item);
    for (let index = 0; index < item.length; index++) {
      console.log("sssssssssss", item[index].T_Product);
      if (
        item[index].T_Code !== "" &&
        typeof item[index].T_Code !== "undefined"
      ) {
        let unitname = "";
        await checkunit(item[j].T_Unitcode).then((data) => {
          unitname = data;
          item[j].T_Unit = unitname;
          this.setState({ tableData: item });
        });
      }
    }
  };
  _loadData = async (productcodeinrow, value, Search) => {
    var result = "";
    var SearchCode = "";
    if (Search === "0") {
      SearchCode = "&warehouse=" + value;
    }
    if (Search === "1") {
      SearchCode = "&location=" + value;
    }
    var url =
      "STKWAREHOUSE/Search?productcode=" + productcodeinrow + SearchCode;
    console.log(genURL(url));
    await axios
      .get(genURL(url), { timeout: 3600 })
      .then((res) => {
        if (res.data.length > 0) {
          result = {
            WAREHOUSE: res.data[0].WAREHOUSE,
            LOCATION: res.data[0].LOCATION,
          };
        }
      })
      .catch((error) => {
        this.setState({ opensnackbar: true });
        this.setState({ color: "warning" });
        this.setState({ icon: ErrorIcon });
        this.setState({ messagealert: "เกิดข้อผิดพลาด" + error });
      });
    return result;
  };

  onClickTopbar = (e) => {
    console.log(e);
    switch (e) {
      case "save":
        this._onSave();
        break;
      case "new":
        this._ResetThisPage();
        break;
      case "print":
        this._print(null);
        break;
      case "search":
        this.onSearch();
        this.setState({
          titleFullScreenDialog: "ค้นหาใบเบิกสินค้า",
          typeFullScreenDialog: "SearchDoc",
          openFullScreenDialog: true,
        });
        break;
      case "popupissuereq":
        this._setPopup("popupissuereq");
        break;

      // new 26/7/2567
      case "stkJobOrder":
        this.setState({
          titleFullScreenDialog: "เลือกใบสั่งผลิต",
          typeFullScreenDialog: "stkJobOrder",
          openFullScreenDialog: true,
        });
        break;
      case "productAssembly":
        this.setState({
          titleFullScreenDialog: "รวมประกอบสินค้าสำเร็จรูป",
          typeFullScreenDialog: "productAssembly",
          openFullScreenDialog: true,
        });
        break;

      default:
        break;
    }
  };
  CloseDialog = (e) => {
    this.setState({
      openFullScreenDialog: e,
    });
  };
  propsvalue = (data) => {
    console.log(data);
    if (data.source === "CSWAREHOUSEALL") {
      this.setState({ defaultwarehouse: data.warehouse });
      this.setState({ defaultlocetion: data.location });
    }
  };
  CloseDialog = (e) => {
    this.setState({ openFullScreenDialog: e });
  };
  rsStkjobOrder = (e) => {
    this.setState({ openFullScreenDialog: false });

    console.log(e);
    // CONFIRMFLAG: 2
    // COSTTYPE: 0
    // DOCNO: "TJ1001-670810-001"
    // ITEMTAXTYPE: 1
    // JOBNO: "TJ1001-670810-001"
    // LOCATION: "1009001"
    // PRODUCTCODE: "00100291"
    // PRODUCTNAME: "หัวเทียนBP7HS NGK/RC80/RC100"
    // PRODUCTSET: 0
    // PRODUCTSETCODE: ""
    // QUANTITY: "MS4wMA=="
    // REFDOCNO: "TJ1001-670810-001"
    // REFDOCTYPE: 999
    // REFLINEID: 460
    // REFQTY: "MS4wMA=="
    // ROWORDER: 1
    // SELFLAG: 0
    // SERIALFLAG: 0
    // STOCKTYPE: 0
    // UNITCODE: "02"
    // UNITNAME: "ชิ้น"
    // WAREHOUSE: "1009"
    // id: 1

    let data = this.state.tableData;
    for (var i = 0; i < e.length; i++) {
      data[i].T_Code = e[i].PRODUCTCODE;
      data[i].T_Product = e[i].PRODUCTNAME;
      data[i].T_Treasury = e[i].WAREHOUSE;
      data[i].T_Location = e[i].LOCATION;
      data[i].T_Unit = e[i].UNITNAME;
      data[i].T_Unitcode = e[i].UNITCODE;
      data[i].T_QTY = e[i].QUANTITY;
      data[i].T_Request = e[i].REFDOCNO;
      data[i].STOCKTYPE = e[i].STOCKTYPE;
      data[i].T_Jobno = e[i].JOBNO;
      data[i].C9 = "";
      data[i].discount = "";
      data[i].C10 = "";
      data[i].PRODUCTSET = e[i].PRODUCTSET;
      data[i].REFDOCTYPE = e[i].REFDOCTYPE;
      data[i].REFQTY = e[i].REFQTY;
    }
    //   console.log("data", data)
  };
  resultDataProductAssembly = async (e) => {
    this.CloseDialog(false);
    console.log("resultDataProductAssembly", e);
    let productAssembly = [];
    productAssembly.push(e);
    await this.setState({
      productAssemblyData: productAssembly,
    });
    await console.log(
      "resultDataProductAssembly productAssemblyData",
      this.state.productAssemblyData
    );
  };
  render() {
    return (
      <div
        className="PSApp"
        onClick={this.onClick}
        onKeyDown={this.onKeyDown}
        onChange={this.onChange}
        onBlur={this.onBlur}
      >
        <Backdrop open={this.state.openBackdrop} />
        <FullScreenDialog
          open={this.state.openFullScreenDialog}
          title={this.state.titleFullScreenDialog}
          closeDialog={(e) => this.CloseDialog(e)}
        >
          {this.state.typeFullScreenDialog === "SearchDoc" ? (
            <Rechecked Dataselect={(e) => this._reCHK(e)} from="CSSTKISSUE" />
          ) : this.state.typeFullScreenDialog === "stkJobOrder" ? (
            <SelectStkJobOrder
              multiselect={true}
              resultData={(e) => this.rsStkjobOrder(e)}
            />
          ) : this.state.typeFullScreenDialog === "productAssembly" ? (
            <ProductAssembly
              ResultData={(e) => this.resultDataProductAssembly(e)}
              CloseDialog={() => this.CloseDialog(false)}
              DefaultData={this.state.productAssemblyData}
            />
          ) : this.state.typeFullScreenDialog === "popupissuereq" ? (
            <_popupissuereq
              closePopup={this._popupClose.bind(null, "close_PopUpOther")}
              Get_popupissuereq={this._Get_popupissuereq}
              type={this.state.typeFullScreenDialog}
              USERCODE={localStorage.getItem("Username")}
              siteCodeUser={this.state.siteCodeUser}
            />
          ) : this.state.typeFullScreenDialog === "customer" ? (
            <PopupArcode
              closePopup={(e) => this.CloseDialog(e)}
              Get_PopUparcode={this._getPopUparcode}
            />
          ) : this.state.typeFullScreenDialog === "product" ? (
            <PopUpItem
              closePopup={(e) => this.CloseDialog(e)}
              Get_PopUpItem={this.Get_PopUpItem}
              userSite={this.state.siteCodeUser}
              from="CSPRODUCT"
            />
          ) : this.state.typeFullScreenDialog === "setdefaultwarehouse" ||
            this.state.typeFullScreenDialog === "setdefaultwarehousetable" ? (
            <_PopUpwarehouse
              closePopup={(e) => this.CloseDialog(e)}
              type={this.state.OtPopupType}
              Get_PopUpOther={this._getwarehouse}
              productcodeinrow={this.state.productcodeinrow}
              productcodeinrow1={this.state.productcodeinrow1}
              from="CSSTKISSUE"
            />
          ) : (
            <PopUpOther
              closePopup={(e) => this.CloseDialog(e)}
              type={this.state.OtPopupType}
              Get_PopUpOther={this.Get_PopUpOther}
              from="CSSTKISSUE"
              userSite={this.state.siteCodeUser}
            />
          )}
        </FullScreenDialog>
        {this.state.showform ? (
          <PopUpReport close={this.switchshowform} url={this.state.urlsend} />
        ) : null}
        <div className="Productbring">
          <Topbar
            listmenu={listmenu}
            title="บันทึกใบเบิกสินค้า"
            onClick={(e) => this.onClickTopbar(e)}
          />
          <div className="PSAppfrom">
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} md={4}>
                <MaterialUIPickers
                  title="วันที่ขอเบิก"
                  DateValue={(e) => this.SelectSetData("Calendar", e)}
                  defaultdate={this.state.withdrawaldate}
                  open={this.state.checkenableInput["DOCDATE"]}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <div className="form-group input-Bottom">
                  <div className="input-group">
                    <span className="input-group-addon"> กลุ่มข้อมูล </span>
                    <input id="2" type="hidden" ref={this.Groupdata_code} />
                    <input
                      id="3"
                      type="text"
                      className="form-control"
                      name="Groupdata"
                      ref={this.Groupdata}
                    />
                    <span
                      className="input-group-addon textIcon"
                      onClick={this._setPopup.bind(null, "Groupdata")}
                    >
                      <i>
                        {" "}
                        <ArrowDropDownRoundedIcon fontSize="small" />
                      </i>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <div className="form-group input-Bottom">
                  <div className="input-group">
                    <span className="input-group-addon">เลขที่ใบขอเบิก </span>
                    <input
                      id="4"
                      name="DeliNumber"
                      type="text"
                      className="form-control"
                      ref={this.DeliNumber}
                      readOnly
                    />
                    <span id="iconTaxNumber" className="input-group-addon icon">
                      <i
                        className="fas fa-sync-alt"
                        onClick={() => this.Chackdoc()}
                      ></i>
                    </span>
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className="form-group input-Bottom">
                  <div className="input-group">
                    <span className="input-group-addon">เบิกให้ลูกค้า </span>
                    <input
                      id="5"
                      type="text"
                      className="form-control"
                      name="CustomerCode"
                      ref={this.CustomerCode}
                    />
                    <span
                      className="input-group-addon textIcon"
                      onClick={this._setPopup.bind(null, "customer")}
                    >
                      <i>
                        {" "}
                        <ArrowDropDownRoundedIcon fontSize="small" />
                      </i>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <div className="form-group input-Bottom">
                  <div className="input-group">
                    <span
                      id="iconCustomerName"
                      className="input-group-addon icon"
                    >
                      <i className="fas fa-user"></i>
                    </span>
                    <input
                      id="6"
                      type="text"
                      className="form-control"
                      name="CustomerName"
                      ref={this.CustomerName}
                    />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <div className="form-group input-Bottom">
                  <div className="input-group">
                    <span className="input-group-addon"> ผู้เบิก </span>
                    <input
                      id="7"
                      type="text"
                      className="form-control hidden"
                      ref={this.Csuser_code}
                    />
                    <input
                      id="8"
                      type="text"
                      className="form-control"
                      name="Csuser"
                      ref={this.Csuser}
                      readOnly
                    />
                    <span id="iconTaxNumber" className="input-group-addon icon">
                      <i
                        className="fas fa-sync-alt"
                        onClick={() =>
                          this.onAddValue("Csuser", this.state.siteCodeUser1)
                        }
                      ></i>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <div className="form-group input-Bottom">
                  <div className="input-group">
                    <span className="input-group-addon"> หมายเหตุ </span>
                    <input
                      id="9"
                      type="text"
                      className="form-control"
                      name="remark"
                      ref={this.remark}
                    />
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className="form-group input-Bottom">
                  <div className="input-group">
                    <span className="input-group-addon"> ประเภทการเบิก </span>
                    <input id="10" type="hidden" ref={this.Issuetype_code} />
                    <input
                      id="11"
                      type="text"
                      className="form-control"
                      name="Issuetype"
                      ref={this.Issuetype}
                    />
                    <span
                      className="input-group-addon textIcon"
                      onClick={this._setPopup.bind(null, "Issuetype")}
                    >
                      <i>
                        {" "}
                        <ArrowDropDownRoundedIcon fontSize="small" />
                      </i>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={8}>
                <CustomInputtext
                  title="คลังเริ่มต้น"
                  value={this.state.defaultvaluewarehouse}
                  disabledvalue={true}
                  of_title={false}
                  of_btn={false}
                  source={"CSWAREHOUSEALL"}
                  propsvalue={this.propsvalue}
                />
              </Grid>
              <Grid item xs={12}>
                <BootstrapTable
                  data={this.state.tableData}
                  options={{ noDataText: "...", onRowClick: this._onRowClick }}
                  cellEdit={{
                    mode: "click",
                    blurToSave: true,
                    beforeSaveCell: this.onBeforeSaveCell,
                    afterSaveCell: this._afterSaveCell,
                  }}
                  height="400"
                >
                  <TableHeaderColumn
                    row="0"
                    rowSpan="2"
                    dataField="N"
                    width="20"
                    isKey
                    dataAlign="center"
                    dataFormat={this._chkload.bind(this)}
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    colSpan="2"
                    dataField=""
                    width="150"
                    headerAlign="center"
                    className="colbuttomhidden"
                  >
                    รหัสสินค้า
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="T_Code"
                    headerAlign="center"
                    width="120"
                    editable={this.state.col1}
                  >
                    {" "}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="BTN_Code"
                    dataAlign="center"
                    width="30"
                    columnclass="c_btn"
                    editable={false}
                    dataFormat={this._cellButtonC1.bind(this)}
                    columnClassName="columnClassNameFormat1"
                  >
                    {" "}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    rowSpan="2"
                    dataField="T_Product"
                    editable={false}
                    width="140"
                    dataAlign="center"
                  >
                    ชื่อสินค้า
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    colSpan="2"
                    dataField=""
                    headerAlign="center"
                    width="120"
                    className="colbuttomhidden"
                  >
                    คลัง
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="T_Treasury"
                    editable={this.state.col}
                    width="90"
                    dataAlign="center"
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="BTN_Treasury"
                    dataAlign="center"
                    width="30"
                    columnclass="c_btn"
                    editable={false}
                    dataFormat={this._cellButtonC3.bind(this)}
                    columnClassName="columnClassNameFormat1"
                  >
                    {" "}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    colSpan="2"
                    dataField=""
                    headerAlign="center"
                    width="120"
                    className="colbuttomhidden"
                  >
                    ตำแหน่งเก็บ
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="T_Location"
                    width="90"
                    dataAlign="center"
                    editable={this.state.col}
                  ></TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="BTN_Location"
                    dataAlign="center"
                    width="30"
                    columnclass="c_btn"
                    editable={false}
                    dataFormat={this._cellButtonC4.bind(this)}
                    columnClassName="columnClassNameFormat1"
                  >
                    {" "}
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    rowSpan="2"
                    dataField="T_Unit"
                    editable={false}
                    width="80"
                    dataAlign="center"
                  >
                    หน่วย
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    rowSpan="2"
                    dataField="T_QTY"
                    editable={this.state.col}
                    width="80"
                    dataAlign="center"
                  >
                    ปริมาณ
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="0"
                    rowSpan="2"
                    dataField="T_Request"
                    editable={this.state.col}
                    width="120"
                    dataAlign="center"
                  >
                    ใบขอเบิก
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    row="0"
                    dataField=""
                    headerAlign="center"
                    width="120"
                  >
                    Jobno
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="T_Jobno"
                    editable={false}
                    width="80"
                    dataAlign="center"
                    hidden={false}
                  ></TableHeaderColumn>

                  <TableHeaderColumn
                    row="0"
                    dataField=""
                    headerAlign="center"
                    width="120"
                  >
                    T_Unitcode
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    width="80"
                    dataField="T_Unitcode"
                    editable={false}
                    hidden={false}
                  ></TableHeaderColumn>

                  <TableHeaderColumn
                    row="0"
                    dataField=""
                    headerAlign="center"
                    width="120"
                  >
                    PRODUCTSET
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="PRODUCTSET"
                    width="90"
                    editable={false}
                    hidden={false}
                  >
                    {" "}
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    row="0"
                    dataField=""
                    headerAlign="center"
                    width="120"
                  >
                    STOCKTYPE
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="STOCKTYPE"
                    width="90"
                    editable={false}
                  >
                    {" "}
                  </TableHeaderColumn>

                  <TableHeaderColumn
                    row="0"
                    dataField=""
                    headerAlign="center"
                    width="120"
                  >
                    REFDOCTYPE
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="REFDOCTYPE"
                    width="90"
                    editable={false}
                    hidden={false}
                  ></TableHeaderColumn>

                  <TableHeaderColumn
                    row="0"
                    dataField=""
                    headerAlign="center"
                    width="120"
                  >
                    REFQTY
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    row="1"
                    dataField="REFQTY"
                    width="90"
                    editable={false}
                    hidden={false}
                  >
                    {" "}
                  </TableHeaderColumn>
                </BootstrapTable>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <div className="form-group input-Bottom">
                  <div className="input-group">
                    <span className="input-group-addon"> แผนก </span>
                    <input type="hidden" ref={this.Department_code} />
                    <input
                      id="12"
                      type="text"
                      className="form-control"
                      name="Department"
                      ref={this.Department}
                    />
                    <span
                      className="input-group-addon textIcon"
                      onClick={this._setPopup.bind(null, "Department")}
                    >
                      <i>
                        {" "}
                        <ArrowDropDownRoundedIcon fontSize="small" />
                      </i>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <div className="form-group">
                  <div className="input-group">
                    <SelectDatas
                      origin="PROJECT" // โครงการ
                      valueSelect={(e) => this.SelectSetData("PROJECT", e)} // รับค่ากลับ
                      title="โครงการ"
                      defaultselect={this.state.PROJECT} // ค่าเริ่มต้นของ โครงการ
                    />
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <div className="form-group input-Bottom">
                  <div className="input-group">
                    <span className="input-group-addon"> สาขา </span>
                    <input type="hidden" ref={this.Branch_code} />
                    <input
                      id="13"
                      type="text"
                      className="form-control"
                      name="Branch"
                      ref={this.Branch}
                    />
                    <span
                      className="input-group-addon textIcon"
                      onClick={this._setPopup.bind(null, "Branch")}
                    >
                      <i>
                        {" "}
                        <ArrowDropDownRoundedIcon fontSize="small" />
                      </i>
                    </span>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12}>
                <Panel>
                  <Panel.Heading>
                    <Panel.Title componentClass="h5">
                      ข้อมูลเพิ่มเติม ( User's Field){" "}
                    </Panel.Title>
                  </Panel.Heading>
                  <Panel.Body>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6} md={6}>
                        <div className="form-group input-Bottom">
                          <div className="input-group">
                            <span className="input-group-addon">
                              หมายเลขตัวถัง
                            </span>
                            <input
                              id="14"
                              type="text"
                              className="form-control"
                              ref={this.ProductCode2}
                              tabIndex="10"
                            />
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <div className="form-group input-Bottom">
                          <div className="input-group">
                            <span className="input-group-addon">เลขไมล์</span>
                            <input
                              id="15"
                              type="text"
                              className="form-control Price"
                              ref={this.MileNo}
                              tabIndex="12"
                              maxLength="13"
                            />
                          </div>
                        </div>
                      </Grid>
                    </Grid>
                  </Panel.Body>
                </Panel>
              </Grid>
              {/* end container spacing={0} */}
            </Grid>

            <Snackbar
              place="br"
              color={this.state.color}
              icon={this.state.icon}
              autoClose={this.state.autoClose}
              message={this.state.messagealert}
              open={this.state.opensnackbar}
              closeNotification={() => {
                this.setState({ opensnackbar: false });
              }}
              close
            />
          </div>
        </div>
      </div>
    );
  }
}
